import NextSection from "@components/About/NextSection";
import cx from "classnames";
import styles from "./AdditionalInfo.module.scss";
import Markdown from "@components/Markdown";
import Item from "./Item";
import _ from "lodash";
interface Props {
  // activeTab: string;
  data: any;
}
const components = {
  li: ({ children }: any) => (
    <li>
      <span className="px-2">-</span>
      {children}
    </li>
  ),
};
export default function AdditionalInfo({ data }: Props) {
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <NextSection className={cx(styles.nextSection)}>
        <div className={cx(styles.titleSection)}>{_.get(data, "title")}</div>
      </NextSection>
      {_.map(_.get(data, "informations", []), (d) => ({
        title: d.title,
        content: (
          <div className="flex flex-col">
            <Markdown components={components} content={d.content} />
            {/* {d.content.map((c: any, idx: number) => {
              if (!!c?.label) {
                return (
                  <div
                    key={idx}
                    className={`flex flex-col ${idx > 0 ? "mt-2" : ""}`}
                  >
                    <div className="flex">
                      <div className="px-2">{`•`}</div>
                      <div dangerouslySetInnerHTML={{ __html: c?.label }} />
                    </div>
                    {_.castArray(c?.content).map((s: any, idx: number) => (
                      <div key={idx} className="flex">
                        <div className="pl-6 pr-2">{`-`}</div>
                        <div dangerouslySetInnerHTML={{ __html: s }} />
                      </div>
                    ))}
                  </div>
                );
              } else {
                return (
                  <div key={idx} className="flex">
                    <div className="px-2">{`•`}</div>
                    <div dangerouslySetInnerHTML={{ __html: c }} />
                  </div>
                );
              }
            })} */}
          </div>
        ),
      })).map((item, index) => (
        <Item key={index} data={item} />
      ))}
    </div>
  );
}
